<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Room"
    hide-footer
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Room</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <BFormSelect
          v-model="roomForm.room_category_uuid"
          :options="categories"
          text-field="name"
          value-field="uuid"
          class="form-select"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled
              >Select type room</BFormSelectOption
            >
          </template>
        </BFormSelect>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="roomForm.code"
          placeholder="Room Number"
        >
        </BFormInput>
      </div>
      <div class="form-group">
        <BFormSelect
          v-model="roomForm.status"
          :options="status_rooms"
          text-field="text"
          value-field="value"
          class="form-select"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled
              >Select status room</BFormSelectOption
            >
          </template>
        </BFormSelect>
      </div>
    </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="handleAction" class="mr-2">{{
          roomData && roomData.uuid ? "Update" : "Save"
        }}</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import { onMounted, ref, inject, watch } from "vue";

import {
  BButton,
  BModal,
  // BBadge,
  BForm,
  BFormSelect,
  BFormSelectOption,
  BFormInput,
} from "bootstrap-vue-next";
import roomCategoryRepository from "@/repositories/roomCategoryRepository";
import ToastResponse from "@/components/ToastResponse.vue";

export default {
  components: {
    BForm,
    BFormSelect,
    BFormSelectOption,
    BFormInput,
    BButton,
    BModal,
    ToastResponse,
    // BBadge,
  },
  props: {
    modal: Boolean,
    roomData: Object,
  },
  emits: ["update:modal"],
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const roomRepository = repositories ? repositories.rooms : null;

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const roomForm = ref({
      room_category_uuid: null,
      code: "",
      status: null,
    });

    const status_rooms = ref([
      { text: "Available", value: "available" },
      { text: "Reserved", value: "reserved" },
      { text: "Check In", value: "check_in" },
      { text: "Check Out", value: "check_out" },
      { text: "Dirty", value: "dirty" },
      { text: "Under Maintenance", value: "under_maintenance" },
      { text: "In Cleaning", value: "in_cleaning" },
    ]);

    const categories = ref([]);

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const getRoomCategory = async (params) => {
      await roomCategoryRepository
        .getAll(params)
        .then((res) => {
          categories.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const handleAction = () => {
      props.roomData.uuid ? update() : create();
    };

    const handleError = (e, defaultMessage) => {
      const errors = e.response?.data?.errors;
      return {
        success: false,
        text: errors ? Object.values(errors)[0][0] : defaultMessage,
        toast: true,
      };
    };

    const create = async () => {
      try {
        const postData = await roomRepository.create(roomForm.value);

        Object.assign(modalResponse.value, {
          success: true,
          text: postData.data.message ||"Room CREATED successfully!",
          toast: true,
        });
        updateModal(false);
        roomForm.value = {};
        emit("addOrUpdate");
      } catch (e) {
        modalResponse.value = handleError(e, "Create new room FAILED!");
        console.log(e);
      }
    };

    const update = async () => {
      try {
        const updateData = await roomRepository.update(props.roomData.uuid, roomForm.value);
        console.log("updateData:", updateData);

        modalResponse.value = {
          toast: true,
          text: updateData.data.message ||"Room UPDATED successfully!",
          success: true,
        };

        updateModal(false);
        roomForm.value = {};
        emit("addOrUpdate");
        
        
      }catch(e){
        modalResponse.value = handleError(e, "Update room FAILED!");
        console.log(e);
      }
      
    };

    onMounted(() => {
      getRoomCategory();
    });

    watch(
      () => props.roomData,
      (newData) => {
        if (newData) {
          roomForm.value = { ...newData };
        }
      },
      { immediate: true }
    );

    return {
      create,
      update,
      updateModal,
      handleAction,
      roomForm,
      status_rooms,
      categories,
      modalResponse,
      // label_rooms,
    };
  },
};
</script>

<style></style>
<style></style>
